import React from "react";
import SearchSelect from "@ui-components/Select/GenericSelect";
import {
  CARRIER_MEDIUMS,
  LEG_PRIORITIES,
  carrierMediumText,
  priorityLabel,
  type CarrierMedium,
  type LegPriority,
} from "kontrolEdge/helpers/carrierAccess";

type Field = "medium" | "priority";
type ValueOf<F extends Field> = F extends "medium" ? CarrierMedium : LegPriority;

const optionsFor = (field: Field, emptyLabel: string) => [
  ...(field === "medium"
    ? CARRIER_MEDIUMS.map((value) => ({
        value,
        label: carrierMediumText(value) ?? value,
      }))
    : LEG_PRIORITIES.map((value) => ({
        value,
        label: priorityLabel(value) ?? value,
      }))),
  // "" clears the value.
  { value: "", label: emptyLabel },
];

/**
 * Picker for a leg's medium or priority, Global Admin only. Shared by the
 * Admin Center and the Backhaul detail so both offer the same values.
 */
export function LegCaptureSelect<F extends Field>({
  field,
  legKey,
  value,
  onChange,
  emptyLabel = "—",
}: {
  field: F;
  /** Remounts the picker when the saved value changes. */
  legKey: string | number;
  value: ValueOf<F> | null;
  onChange: (value: ValueOf<F> | null) => void;
  emptyLabel?: string;
}): React.ReactElement {
  return (
    <SearchSelect
      key={`${legKey}:${field}:${value ?? ""}`}
      placeholder={emptyLabel}
      options={optionsFor(field, emptyLabel)}
      defaultValue={value ?? ""}
      onSelect={(selected) => onChange((selected || null) as ValueOf<F> | null)}
    />
  );
}
